import { render, staticRenderFns } from "./finishOrCanelTask.vue?vue&type=template&id=5da2972f&scoped=true"
import script from "./finishOrCanelTask.vue?vue&type=script&lang=js"
export * from "./finishOrCanelTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da2972f",
  null
  
)

export default component.exports